import React from 'react';

import { TextBlock } from 'bench-internal-theme';
import { StatementOCRTabs } from './types';
import {
  StatementOCRHeaderLayout,
  StatementOCRHeaderNavigationLayout,
  StatementOCRTab,
} from './StatementOCRHeader.styles';

interface StatementOCRHeaderProps {
  tab: StatementOCRTabs | undefined;
  updateQueryParams: (arg0: object) => void;
}

const StatementOCRHeader = ({ tab, updateQueryParams }: StatementOCRHeaderProps) => (
  <StatementOCRHeaderLayout>
    <TextBlock styleType="title">Statement OCR</TextBlock>
    <StatementOCRHeaderNavigationLayout>
      <StatementOCRTab
        isActive={tab === StatementOCRTabs.UPLOAD}
        onClick={() => updateQueryParams({ tab: StatementOCRTabs.UPLOAD })}
      >
        Upload
      </StatementOCRTab>
    </StatementOCRHeaderNavigationLayout>
  </StatementOCRHeaderLayout>
);

export default StatementOCRHeader;
